module.exports = __webpack_public_path__ + "static/media/tanfolyamok.e7c57b6d.png";